module.exports = __webpack_public_path__ + "static/og-image-2990e3501db2bbb1833c3e482d7fb634.png";